module.exports = __webpack_public_path__ + "static/media/ios-attach.fe71219f.svg";